import { createContext } from "react";

export const UPMDispatchContext = createContext();
